<template>
  <div v-if="status == 'done'">
    <audio @timeupdate="updateProgress" controls ref="audioRef" style="display: none">
      <source :src="fileurl" type="audio/mpeg" />
      <source :src="fileurl" type="audio/mp4" />
      <source :src="fileurl" type="audio/ogg" />
    </audio>
    <div class="audio-right">
      <img :src="audioStatus === 'pause' ? pause : start" @click="playAudio" class="dialogAudioPlay">
      <div class="audio-info">
        <i class="audio-name">{{ fileName }}</i>
        <span class="audio-length-current">{{ duration }}</span>
      </div>
      <div class="z-wrong">
        <z-icon name="zlj-close-o" class-prefix="zziconfont" @click.stop="removeFile" />
      </div>
    </div>
  </div>
  <div v-else class="audio-right" style="justify-content: center; display: flex; align-items: center;">
    <z-loading type="spinner" size="16px"/>
    <span style="color: #999; margin-left: 10px">上传中，请稍等</span>
  </div>
</template>

<script>

import { Icon, Loading } from '@zz-common/zz-ui'
export default {
  name: 'AudioPlayer',
  props: {
    fileurl: {
      type: String
    },
    fileName: {
      type: String
    },
    index: {
      type: Number
    },
    status: {
      type: String
    }
  },
  components: {
    'z-icon': Icon,
    'z-loading': Loading
  },
  data() {
    return {
      audioStatus: 'play',
      audioStart: '0:00',
      duration: '0:00',
      audioVolume: 0.5,
      audioHuds: false,
      start: require('../../images/bofang.png'),
      pause: require('../../images/pause.png')
    }
  },

  computed: {
    audioIcon() {
      if (this.audioHuds) {
        return this.audioVolume < 0.01 ? 'checked icon-jingyin' : 'checked icon-shengyin'
      } else {
        return 'icon-shengyin'
      }
    }
  },
  mounted() {
    if (this.status == 'done') this.fetch() //上传完成才拉取音频信息
  },
  methods: {
    fetch() {
      const that = this
      const myVid = this.$refs.audioRef
      myVid.loop = false
      // 监听音频播放完毕
      myVid.addEventListener(
        'ended',
        function () {
          that.audioStatus = 'play' // 显示播放icon
          document.getElementById('progressBar').style.width = '0%' // 进度条初始化
        },
        false
      )
      if (myVid != null) {
        myVid.oncanplay = function () {
          that.duration = that.transTime(myVid.duration) // 计算音频时长
        }
        myVid.volume = 0.5 // 设置音量50%
      }
    },
    // 播放暂停控制
    playAudio() {
      const recordAudio = this.$refs.audioRef // 获取audio元素
      if (recordAudio.paused) {
        recordAudio.play()
        this.audioStatus = 'pause'
      } else {
        recordAudio.pause()
        this.audioStatus = 'play'
      }
    },
    // 更新进度条与当前播放时间
    updateProgress(e) {
      const value = e.target.duration - e.target.currentTime
      if (value == 0) this.audioStatus = 'pause'

      this.duration = this.transTime(value)
    },
    /**
     * 音频播放时间换算
     * @param {number} value - 音频当前播放时间，单位秒
     */
    transTime(time) {
      const duration = parseInt(time)
      let minute = parseInt(duration / 60)
      let sec = (duration % 60) + ''
      const isM0 = ':'
      if (minute === 0) {
        minute = '00'
      } else if (minute < 10) {
        minute = '0' + minute
      }
      if (sec.length === 1) {
        sec = '0' + sec
      }
      return minute + isM0 + sec
    },
    removeFile(index) {
      this.$emit('remove', index)
    }
  }
}
</script>

<style lang='less' scoped>
@import "index.less";
</style>
